<style lang="less">
@import "./index.less";
</style>

<template>
  <div class="login-container">

    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">重置密码</h3>
      </div>

      <el-form-item prop="email">
        <span class="icon-container">
          <icon name="perm_identity" />
        </span>
        <el-input v-model="loginForm.email" placeholder="请输入邮箱" name="email" type="text" auto-complete="on" />
      </el-form-item>

      <el-form-item prop="email">
        <span class="icon-container">
          <icon name="lock" />
        </span>
        <el-input v-model="loginForm.code" placeholder="请输入邮箱验证码" name="email" type="text" auto-complete="on" />
        <el-link class="send-code" :disabled="!dynamicCode.canClick" type="primary" @click.native.prevent="sendCode">{{dynamicCode.buttonText}}</el-link>
      </el-form-item>

      <el-form-item prop="password">
        <span class="icon-container">
          <icon name="lock" />
        </span>
        <el-input :type="passwordType" v-model="loginForm.password" placeholder="请输入新密码" name="password"
                  auto-complete="on" @keyup.enter.native="login" />
        <span class="show-pwd" @click="showPwd">
          <icon :name="passwordType == 'password' ? 'visibility' : 'visibility_off'" />
        </span>
      </el-form-item>

      <el-form-item prop="password">
        <span class="icon-container">
          <icon name="lock" />
        </span>
        <el-input :type="repeatPasswordType" v-model="loginForm.repeatPassword" placeholder="请输入密码" name="password"
                  auto-complete="on" @keyup.enter.native="login" />
        <span class="show-pwd" @click="showRepeatPwd">
          <icon :name="repeatPasswordType == 'password' ? 'visibility' : 'visibility_off'" />
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary" class="green-btn" style="width:100%;margin-bottom:30px;"
                 @click.native.prevent="submit">提交</el-button>

      <div style="text-align: right;">
        <el-link type="primary" href="/login">返回登录</el-link>
      </div>
    </el-form>

  </div>
</template>

<script>
const countTime = 60

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        code: '',
        password: '',
        repeatPassword: '',
      },
      dynamicCode: {
        'buttonText': '发送验证码',
        'totalTime': countTime,
        'canClick': true,
      },
      loginRules: {
        email: this.$formHelper.rules.emailRequired,
        code : [{ required: true, message: '请输入邮箱验证码', trigger: 'blur' }],
        password: this.$formHelper.rules.passwordRequired ,
        repeatPassword : [{ required: true, message: '请输入邮箱验证码', trigger: 'blur' }],
      },
      passwordType: 'password',
      repeatPasswordType: 'password',
      loading: false,
      redirectToName: undefined
    }
  },
  computed: {
    appTitle() {
      return this.$config.title
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirectToName = route.query && route.query.redirectToName
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    showRepeatPwd() {
      if (this.repeatPasswordType === 'password') {
        this.repeatPasswordType = ''
      } else {
        this.repeatPasswordType = 'password'
      }
    },
    async submit() {
      await this.$formHelper.promisedValidate(this.$refs.loginForm)
      if (this.loginForm.password != this.loginForm.repeatPassword) {
        this.$message.error('确认密码与新密码不一致')
        return ;
      }
      try {
        this.loading = true
        await this.$store.dispatch('auth/resetPassword', this.loginForm)
        this.$message.success('密码更新成功，返回登录页登录')
        this.$router.push('/login')
      } finally {
        this.loading = false
      }
    },
    async sendCode() {
      if (!this.dynamicCode.canClick) return
      const { email } = this.loginForm
      if (!email) {
        this.$message.error('请输入您的邮箱')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        this.dynamicCode.canClick = false
        await this.$store.dispatch('code/send', this.loginForm)
      } catch (e) {
        this.dynamicCode.canClick = true
        return false;
      } finally {
        loading.close()
      }
      this.countDown()
      this.$alert(`验证码已发送到您的${email}邮箱请查收，可能会有2～3分钟的收件延迟请稍等；如未收到，可在第一次获取60s后重试；`)
    },
    countDown () {
      this.dynamicCode.canClick = false
      this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
      let clock = window.setInterval(() => {
        this.dynamicCode.totalTime--
        this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
        if (this.dynamicCode.totalTime < 0) {
          window.clearInterval(clock)
          this.dynamicCode.buttonText = '重新发送验证码'
          this.dynamicCode.totalTime = countTime
          this.dynamicCode.canClick = true   //这里重新开启
        }
      },1000)
    }
  }
}
</script>
